import { render } from "./rolePower.vue?vue&type=template&id=579f1cf7&scoped=true"
import script from "./rolePower.vue?vue&type=script&lang=js"
export * from "./rolePower.vue?vue&type=script&lang=js"

import "./rolePower.vue?vue&type=style&index=0&id=579f1cf7&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579f1cf7"]])

export default __exports__